import { APIResult } from 'src/modules/models/api-result';

export class BookingSearchResult extends APIResult {
    data: any = []
    total: number = 0;
}